import {ValueObject} from '@s-ui/domain'

import {InvalidParamsSharedError} from '../../shared/Errors/InvalidParamsSharedError.js'
import {ListProductsTrackingDataValueObject} from './ListProductsTrackingDataValueObject.js'

export class VehicleConfiguratorLeadTrackingDataValueObject extends ValueObject {
  #brand
  #brandId
  #event
  #filteredProvinces
  #hitInformation
  #hitInformation2
  #hitInformation3
  #leadType
  #model
  #modelId
  #products

  constructor({
    brand,
    brandId,
    event,
    filteredProvinces,
    hitInformation,
    hitInformation2,
    hitInformation3,
    leadType,
    model,
    modelId,
    products
  }) {
    super()
    this.#brand = brand
    this.#brandId = brandId
    this.#event = event
    this.#filteredProvinces = filteredProvinces
    this.#hitInformation = hitInformation
    this.#hitInformation2 = hitInformation2
    this.#hitInformation3 = hitInformation3
    this.#leadType = leadType
    this.#model = model
    this.#modelId = modelId
    this.#products = products
  }

  static validate({contactRequestId, brand, brandId, model, modelId, dealerId, zipcode, distance}) {
    if (!contactRequestId || !brand || !brandId || !model || !modelId || !dealerId || !zipcode || !distance) {
      const missingParams = Object.entries({
        contactRequestId,
        brand,
        brandId,
        model,
        modelId,
        dealerId,
        zipcode,
        distance
      })
        .filter(([key, value]) => !value)
        .map(([key]) => key)
        .join(', ')
      throw InvalidParamsSharedError.create(
        `[VehicleConfiguratorLeadTrackingDataValueObject.validate] param${
          missingParams.includes(',') ? 's' : ''
        } ${missingParams} ${missingParams.includes(',') ? 'are' : 'is'} required`
      )
    }
  }

  static create({contactRequestId, brand, brandId, model, modelId, dealerId, zipcode, distance}) {
    VehicleConfiguratorLeadTrackingDataValueObject.validate({
      contactRequestId,
      brand,
      brandId,
      model,
      modelId,
      dealerId,
      zipcode,
      distance
    })
    return new VehicleConfiguratorLeadTrackingDataValueObject({
      brand,
      brandId,
      event: 'Lead Triggered',
      filteredProvinces: 'all',
      hitInformation: zipcode,
      hitInformation2: distance,
      hitInformation3: contactRequestId,
      leadType: 'Car Configurator Email',
      model,
      modelId,
      products: ListProductsTrackingDataValueObject.create({
        value: [
          {
            category: 'dealer',
            id: `dealer${dealerId}`,
            price: 0,
            quantity: 0
          }
        ]
      })
    })
  }

  get event() {
    return this.#event
  }

  get leadType() {
    return this.#leadType
  }

  get brand() {
    return this.#brand
  }

  get brandId() {
    return this.#brandId
  }

  get model() {
    return this.#model
  }

  get modelId() {
    return this.#modelId
  }

  get filteredProvinces() {
    return this.#filteredProvinces
  }

  get products() {
    return this.#products
  }

  get hitInformation() {
    return this.#hitInformation
  }

  get hitInformation2() {
    return this.#hitInformation2
  }

  get hitInformation3() {
    return this.#hitInformation3
  }

  get value() {
    return {
      brand: this.brand,
      brandId: this.brandId,
      event: this.event,
      filteredProvinces: this.filteredProvinces,
      hitInformation: this.hitInformation,
      hitInformation2: this.hitInformation2,
      hitInformation3: this.hitInformation3,
      leadType: this.leadType,
      model: this.model,
      modelId: this.modelId,
      products: this.products.value
    }
  }

  toSegmentTrack() {
    return {
      event: this.#event,
      data: {
        brand_id: this.#brandId,
        brand: this.#brand,
        filtered_provinces: this.#filteredProvinces,
        hit_information: this.#hitInformation,
        hit_information2: this.#hitInformation2,
        hit_information3: this.#hitInformation3,
        lead_type: this.#leadType,
        model_id: this.#modelId,
        model: this.#model,
        products: this.products.value
      }
    }
  }
}
